import styled from 'styled-components';

export const TooltipStyled = styled.div`
  text-align: left;
  padding: 3px 6px;
  font-size: 13px;
  line-height: 1.5;
  color: #fff;
  overflow-wrap: break-word;
`;
